/*
Fit Guide Category
*/

class FitGuideCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const target = this.querySelector(".select-type-target-js");
    const categorysButtons = this.querySelectorAll(".categorys-buttons button");
    const heroContainers = document.querySelectorAll(".hero-container");
    const herosNewContainer = document.querySelector(".heros-new-container");

    heroContainers.forEach((heroContainer) => {
      herosNewContainer.appendChild(heroContainer);
      heroContainer.classList.add("hidden");

      const title = heroContainer.querySelector("h1") || heroContainer.querySelector("h2");
      if (
        title.innerHTML
          .toLocaleLowerCase()
          .includes(target.innerHTML.toLocaleLowerCase())
      ) {
        heroContainer.classList.remove("hidden");
      }
    });

    const positionTop = herosNewContainer.getBoundingClientRect().top;

    window.scrollBy({
      top: positionTop - 85,
      behavior: "instant",
    });

    this.querySelector("select").addEventListener("change", (e) => {
      const options = Array.from(this.querySelectorAll("option"));
      const active = options.find((o) => o.value === e.target.value);

      if (!!e.target.value) {
        target.innerHTML = active.innerHTML;
        heroContainers.forEach((heroContainer) => {
          heroContainer.classList.add("hidden");
          const title = heroContainer.querySelector("h1") || heroContainer.querySelector("h2");
          if (
            title.innerHTML
              .toLocaleLowerCase()
              .includes(target.innerHTML.toLocaleLowerCase())
          ) {
            heroContainer.classList.remove("hidden");
          }
        });
      }
    });

    const activateCategory = (button) => {
      categorysButtons.forEach((button) => {
        button.classList.remove("text-white", "bg-black", "border-black");
      });
      target.innerHTML = button.innerHTML;
      button.classList.add("text-white", "bg-black", "border-black");
      heroContainers.forEach((heroContainer) => {
        const title = heroContainer.querySelector("h1") || heroContainer.querySelector("h2");
        heroContainer.classList.add("hidden");
        if (
          title.innerHTML
            .toLocaleLowerCase()
            .includes(target.innerHTML.toLocaleLowerCase())
        ) {
          heroContainer.classList.remove("hidden");
        }
      });
    };

    categorysButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activateCategory(button);
      });
    });
  }
}

customElements.define("fit-guide-category", FitGuideCategory);

/*
Fit Guide Garment
*/

class FitGuideGarment extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll("button");

    this.selectGarment();
  }

  selectGarment() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        this.buttons.forEach((button) => {
          button.classList.add("opacity-40");
          button.classList.remove("selected-garment-js");
        });
        button.classList.remove("opacity-40");
        button.classList.add("selected-garment-js");
      });
    });
  }
}

customElements.define("fit-guide-garment", FitGuideGarment);

/* Guide Filter */

class FitGuideFilterProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.filterButtons = this.querySelectorAll(".filter-buttons-js");
    this.navigationFabricGuideContainer =
      document.querySelector(".scroll-target-js");
    this.activeCategory = document.querySelector(".select-type-target-js");
    this.garmentButtons = document.querySelectorAll("fit-guide-garment button");
    this.garmentsImagesButtons = document.querySelectorAll(
      "fit-guide-garment button img"
    );

    this.productsContainers = this.querySelectorAll(".product-container-js");
    this.tablesContainers = document.querySelectorAll(
      ".tables-content-js table"
    );
    this.fitGuideFiltersDetails = document.querySelector(
      "#fit-guide-filters-details-js"
    );
    this.rawFitGuideFiltersDetails = this.fitGuideFiltersDetails.innerHTML;
    this.fitGuideFiltersDetailsTreated = JSON.parse(
      this.rawFitGuideFiltersDetails
    );

    this.setCategoryFiltersDefault();
    this.renderGarmentsImages();

    this.selectCategoryFilters();

    this.setGarmentFiltersDefault();
    this.garmentButtonsAction();
    this.renderAvailablesGarments();

    this.filterStyleTypes();
  }

  setCategoryFiltersDefault() {
    const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();

    this.garmentButtons.forEach((garmentButton) => {
      const garment = garmentButton.dataset.garment;
      const garmentExists = this.fitGuideFiltersDetailsTreated.some(
        (item) =>
          item.category === categoryTypeTreated && item.garment === garment
      );
      garmentButton.style.display = garmentExists ? "grid" : "none";
    });

    this.productsContainers.forEach((productContainer) => {
      productContainer.classList.add("hidden");

      if (productContainer.dataset.category === categoryTypeTreated) {
        productContainer.classList.remove("hidden");
      }
    });

    this.renderTable();
  }

  selectCategoryFilters() {
    const selectCategoryFilters = document.querySelector(
      "fit-guide-category select"
    );
    const categorysButtons = document.querySelectorAll(
      ".categorys-buttons button"
    );

    categorysButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.setGarmentFiltersDefault();
        this.renderGarmentsImages();
      });
    });

    selectCategoryFilters.addEventListener("change", () => {
      this.setGarmentFiltersDefault();
      this.renderGarmentsImages();
    });
  }

  renderGarmentsImages() {
    this.garmentsImagesButtons.forEach((image) => {
      image.classList.add("hidden");
      if (
        image.classList.contains(this.activeCategory.innerHTML.toLowerCase())
      ) {
        image.classList.remove("hidden");
      } else {
        image.classList.add("hidden");
      }
    });
  }

  setGarmentFiltersDefault() {
    this.filterButtons = this.querySelectorAll(".filter-buttons-js");
    const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();

    this.filterButtons.forEach((filterButton) => {
      filterButton.classList.add("hidden");
    });

    this.productsContainers.forEach((productContainer) => {
      productContainer.classList.add("hidden");
      const selectedGarment = document.querySelector(".selected-garment-js");

      if (
        productContainer.dataset.category === categoryTypeTreated &&
        selectedGarment.dataset.garment === productContainer.dataset.garment
      ) {
        productContainer.classList.remove("hidden");
      }
      if (!productContainer.classList.contains("hidden")) {
        const shownStyles = new Set();
        this.filterButtons.forEach((filterButton) => {
          if (
            filterButton.innerHTML === "All Styles" ||
            filterButton.innerHTML === productContainer.dataset.style_type
          ) {
            if (!shownStyles.has(filterButton.innerHTML)) {
              filterButton.classList.remove("hidden");
              shownStyles.add(filterButton.innerHTML);
            } else {
              filterButton.classList.add("hidden");
            }
          }
        });
      }
      this.renderTable();
    });
  }

  garmentButtonsAction() {
    this.garmentButtons.forEach((garmentButton) => {
      garmentButton.addEventListener("click", () => {
        this.renderTable();
        const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();

        this.filterButtons.forEach((filterButton) => {
          filterButton.classList.add("hidden");
        });

        this.productsContainers.forEach((productContainer) => {
          productContainer.classList.add("hidden");
          const selectedGarment = document.querySelector(
            ".selected-garment-js"
          );

          if (
            productContainer.dataset.category === categoryTypeTreated &&
            selectedGarment.dataset.garment === productContainer.dataset.garment
          ) {
            productContainer.classList.remove("hidden");
          }
          if (!productContainer.classList.contains("hidden")) {
            const shownStyles = new Set();
            this.filterButtons.forEach((filterButton) => {
              if (
                filterButton.innerHTML === "All Styles" ||
                filterButton.innerHTML === productContainer.dataset.style_type
              ) {
                if (!shownStyles.has(filterButton.innerHTML)) {
                  filterButton.classList.remove("hidden");
                  shownStyles.add(filterButton.innerHTML);
                } else {
                  filterButton.classList.add("hidden");
                }
              }
              this.filterButtons.forEach((btn) => {
                btn.classList.add("opacity-30");
                if (btn.innerHTML === "All Styles") {
                  btn.classList.remove("opacity-30");
                }
              });
            });
          }
        });
      });
    });
  }

  renderAvailablesGarments() {
    const selectCategoryFilters = document.querySelector(
      "fit-guide-category select"
    );

    const categorysButtons = document.querySelectorAll(
      ".categorys-buttons button"
    );

    const renderingAvailablesGarments = () => {
      {
        const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();
        const selectedGarment = document.querySelector(".selected-garment-js");

        this.productsContainers.forEach((productContainer) => {
          productContainer.classList.add("hidden");

          this.garmentButtons.forEach((garmentButton) => {
            const garment = garmentButton.dataset.garment;
            const garmentExists = this.fitGuideFiltersDetailsTreated.some(
              (item) =>
                item.category === categoryTypeTreated &&
                item.garment === garment
            );
            garmentButton.style.display = garmentExists ? "grid" : "none";
          });

          if (
            productContainer.dataset.category === categoryTypeTreated &&
            selectedGarment.dataset.garment === productContainer.dataset.garment
          ) {
            productContainer.classList.remove("hidden");
          }
        });
      }
    };

    categorysButtons.forEach((button) => {
      button.addEventListener("click", renderingAvailablesGarments);
    });

    selectCategoryFilters.addEventListener(
      "change",
      renderingAvailablesGarments
    );
  }

  filterStyleTypes() {
    this.filterButtons.forEach((filterButton) => {
      filterButton.addEventListener("click", () => {
        const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();
        const positionTop =
          this.navigationFabricGuideContainer.getBoundingClientRect().top;

        window.scrollBy({
          top: positionTop - 85,
          behavior: "instant",
        });

        const selectedGarment = document.querySelector(".selected-garment-js");

        this.filterButtons.forEach((btn) => {
          btn.classList.add("opacity-30");
        });

        this.productsContainers.forEach((productContainer) => {
          productContainer.classList.add("hidden");

          if (
            productContainer.dataset.category === categoryTypeTreated &&
            selectedGarment.dataset.garment ===
              productContainer.dataset.garment &&
            productContainer.dataset.style_type ===
              filterButton.dataset.style_type
          ) {
            productContainer.classList.remove("hidden");
            filterButton.classList.remove("opacity-30");
          }

          if (
            filterButton.innerHTML === "All Styles" &&
            productContainer.dataset.category === categoryTypeTreated &&
            selectedGarment.dataset.garment === productContainer.dataset.garment
          ) {
            productContainer.classList.remove("hidden");
            filterButton.classList.remove("opacity-30");
          }
        });
      });
    });
  }

  renderTable() {
    const categoryTypeTreated = this.activeCategory.innerHTML.toLowerCase();
    const selectedGarment = document.querySelector(".selected-garment-js");

    this.tablesContainers.forEach((table) => {
      if (
        table.dataset.category === categoryTypeTreated &&
        table.dataset.garment == "none"
      ) {
        table.classList.remove("hidden");
      } else {
        table.classList.add("hidden");
      }

      if (
        table.dataset.category === categoryTypeTreated &&
        selectedGarment.dataset.garment === table.dataset.garment
      ) {
        return table.classList.remove("hidden");
      }
    });
  }
}

customElements.define("fit-guide-filtered-products", FitGuideFilterProducts);
